import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as ConveyorAPI from './conveyorAPI';

export const listConveyor = createAsyncThunk('conveyors/list', async ({ projectId, page, username, tag }, { rejectWithValue }) => {
    try {
        const response = await ConveyorAPI.listConveyor({ projectId, page, username, tag });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.resposne.data);
    }
});

const initialState = {
    conveyors: null,
    error: null,
    lastPage: 1,
};

const conveyorsSlice = createSlice({
    name: 'conveyors',
    initialState,
    reducers: {
        unloadConveyorList: state => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(listConveyor.fulfilled, (state, { payload }) => {
                state.conveyors = payload;
                state.error = null;
            })
            .addCase(listConveyor.rejected, (state, { payload }) => {
                state.conveyors = null;
                state.error = payload;
            })
    },
});

export const { unloadConveyorList } = conveyorsSlice.actions;
export default conveyorsSlice.reducer;